import { useNavigate } from 'react-router-dom'
import { Button, CardContainer, Input, InputDomisili } from '../../../components'
import { REGIONAL } from '../../../routes/routesNames'
import UseFormDomisili from '../hookForm'

const EditRegional = () => {
    const navigate = useNavigate();
    const {
        handleSubmit,
        form,
        handleChange,
        isLoadingPut,
    } = UseFormDomisili({
        type : 'put',
        redirect : REGIONAL,
        url : '/v1/domain',
        formType : 'regional'
    })

    const isEnable = form.name && form.domisiliSelected.length  ;

  return (
      <CardContainer>
        <form onSubmit={e => isEnable ? handleSubmit(e) : e.preventDefault()}>
            <div className="col-xl-8 col-lg-10 col-12">
                <Input
                    value={form.name}
                    id="name"
                    onChange={handleChange} 
                    placeholder="Masukan Regional" 
                    label="Regional" />
                <InputDomisili
                    value={form.domisiliSelected}
                    id="domisiliSelected"
                    onChange={handleChange}
                    label="Domisili" />
                <div className="d-flex justify-content-end">
                    <div className="me-4">
                        <Button 
                            onClick={() => navigate(-1)}
                            type="button"
                            className={`btn-light w-100 mt-4 px-5`} 
                            title="Batalkan" />
                    </div>
                    <Button 
                        type="submit"
                        className={`${isEnable  ? 'btn-primary' : 'btn-secondary'}  w-100 mt-4 px-5`} 
                        title="Ubah" 
                        isLoading={isLoadingPut} />
                </div>
            </div>
        </form>
      </CardContainer>
  )
}

export default EditRegional